module.exports = {"430781001":"三洲驿街道","430781002":"汪家桥街道","430781003":"襄阳街街道","430781004":"金鱼岭街道","430781005":"嘉山街道","430781100":"新洲镇","430781103":"白衣镇","430781105":"药山镇","430781106":"毛里湖镇","430781500":"涔澹农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430781.json
// module id = 1716
// module chunks = 0